export const page_sides_g: string = "12%";
export const page_top_g: string = "100px";
